// extracted by mini-css-extract-plugin
module.exports = {"projectContainer":"ProjectHome_projectContainer__2Dp-n"};